import { onApiError } from '../error'
import { put } from './client'

/**
 * @param {string} email
 * @param {string} code
 */
async function verifyEmail(email, code) {
    const res = await put(`/verify-email`, {
        body: JSON.stringify({
            Email: email,
            VerificationCode: code
        })
    })

    if (!res.ok) throw await onApiError(res)
}

export {
    verifyEmail
}
